import { React, useEffect, useMemo, useState } from "react";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import { useLocation, useNavigate } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { getBrands } from "../features/brand/brandSlice";
import { getCategories } from "../features/pcategory/pcategorySlice";
import { getColors } from "../features/color/colorSlice";
import { Select } from "antd";
import Dropzone from "react-dropzone";
import { delImg, uploadImg } from "../features/upload/uploadSlice";
import {
  createProducts,
  getAProduct,
  resetState,
  updateAProduct,
} from "../features/product/productSlice";
import { FeaturedArray } from "../components/commonData";

let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  // author_name:yup.string().required("Author Name is Required"),
  description: yup.string().required("Description is Required"),
  price: yup.number().required("Price is Required"),
  current_price: yup.number().required("Current Price is Required"),
  brand: yup.string().required("Brand is Required"),
  category: yup.string().required("Category is Required"),
  tags: yup.string().required("Tag is Required"),
  // isbn: yup.number().required("ISBN is Required"),
  color: yup
    .array()
    .min(1, "Pick at least one color")
    .required("Color is Required"),
  quantity: yup.number().required("Quantity is Required"),
  size: yup.array().nullable(),
});

const Addproduct = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const getProductId = location.pathname.split("/")[3];
  const navigate = useNavigate();
  const [color, setColor] = useState([]);
  const [images, setImages] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    dispatch(getBrands());
    dispatch(getCategories());
    dispatch(getColors());
  }, []);

  const brandState = useSelector((state) => state.brand.brands);
  const catState = useSelector((state) => state.pCategory.pCategories);
  const colorState = useSelector((state) => state.color.colors);
  const imgState = useSelector((state) => state?.upload?.images);
  const newProduct = useSelector((state) => state.product);
  const tags = [
    { id: 1, value: "now_trending", name: "Now Trending" },
    { id: 2, value: "best_seller", name: "Best Seller" },
    { id: 3, value: "new_arrival", name: "New Arrival" },
  ];

  const {
    isSuccess,
    isError,
    isLoading,
    createdProduct,
    updatedProduct,
    productName,
    productDesc,
    productPrice,
    currentPrice,
    productBrand,
    productCategory,
    productTag,
    productColors,
    productQuantity,
    productImages,
    productSize,
    // author_name,
    // isbn
  } = newProduct;

  useEffect(() => {
    if (getProductId !== undefined) {
      dispatch(getAProduct(getProductId));
    } else {
      dispatch(resetState());
    }
  }, [getProductId]);

  useEffect(() => {
    if (submitted && isSuccess && createdProduct) {
      toast.success("Product Added Successfullly!");
      setSubmitted(false);
    }
    if (submitted && isSuccess && updatedProduct) {
      toast.success("Product Updated Successfullly!");
      setSubmitted(false);
      navigate("/admin/list-product");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
      setSubmitted(false);
    }
  }, [isSuccess, isError, isLoading, createdProduct, updatedProduct, submitted]);

  const coloropt = [];
  colorState.forEach((i) => {
    coloropt.push({
      label: (
        <div className="col-3">
          <ul
            className="colors ps-0"
            style={{
              width: "20px",
              height: "20px",
              marginBottom: "10px",
              backgroundColor: i.title,
              borderRadius: "50%",
              listStyle: "none",
              border: "2px solid transparent",
            }}
          ></ul>
        </div>
      ),
      value: i._id,
    });
  });

  const productcolor = [];
  productColors?.forEach((i) => {
    productcolor.push({
      label: (
        <div className="col-3">
          <ul
            className="colors ps-0"
            style={{
              width: "20px",
              height: "20px",
              marginBottom: "10px",
              backgroundColor: i.title,
              borderRadius: "50%",
              listStyle: "none",
              border: "2px solid transparent",
            }}
          ></ul>
        </div>
      ),
      value: i._id,
    });
  });

  const imgSource =
    productImages && productImages.length > 0 ? productImages : imgState;

  const img =
    imgSource?.map((i) => ({
      public_id: i.public_id,
      url: i.url,
    })) || [];

  const imgshow = [];
  productImages?.forEach((i) => {
    imgshow.push({
      public_id: i.public_id,
      url: i.url,
    });
  });

  // Initialize formik values
  const initialValues = useMemo(() => {
    const values = {
      title: productName || "",
      // author_name: author_name || "",
      current_price: currentPrice || "",
      description: productDesc || "",
      price: productPrice || "",
      brand: productBrand || "",
      category: productCategory || "",
      tags: productTag || "",
      quantity: productQuantity || "",
      images: images || "",
      color: productColors || [],
      size: productSize || [],
      // isbn:isbn || ""
    };
    
    // Update local color state when productColors is available
    if (productColors && productColors.length > 0 && !color.length) {
      const colorIds = productColors.map(c => c._id);
      setColor(colorIds);
    }
    
    return values;
  }, [
    productName,
    // author_name,
    currentPrice,
    productDesc,
    productPrice,
    productBrand,
    productCategory,
    productTag,
    productQuantity,
    productImages,
    images,
    productColors,
    productSize,
    // isbn
  ]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      setSubmitted(true);
      // Ensure color data is properly formatted
      const formattedValues = {
        ...values,
        color: color.length > 0 ? color : values.color,
        images: img.length > 0 ? img : values.images,
        size: values.size.length > 0 ? values.size : [],
      };

      if (getProductId !== undefined) {
        const data = { id: getProductId, productData: formattedValues };
        dispatch(updateAProduct(data));
      } else {
        dispatch(createProducts(formattedValues));
        formik.resetForm();
        setColor([]);
        setTimeout(() => {
          dispatch(resetState());
        }, 3000);
      }
    },
  });

  const handleColors = (e) => {
    setColor(e);
    formik.setFieldValue("color", e);
  };

  const handleSize = (value) => {
    formik.setFieldValue("size", value);
  };

  // Update images when imgState changes
  useEffect(() => {
    if (imgState && imgState.length > 0) {
      const formattedImages = imgState.map((i) => ({
        public_id: i.public_id,
        url: i.url,
      }));
      formik.setFieldValue("images", formattedImages);
    }
  }, [imgState]);

  // Update formik values when color changes
  useEffect(() => {
    if (color && color.length > 0) {
      formik.setFieldValue("color", color);
    }
  }, [color]);

  return (
    <div>
      <h3 className="mb-4 title">
        {getProductId !== undefined ? "Edit" : "Add"} Product
      </h3>
      <div>
        <form
          onSubmit={formik.handleSubmit}
          className="d-flex gap-3 flex-column"
        >
          <CustomInput
            type="text"
            label="Enter Product Title"
            name="title"
            onChng={formik.handleChange("title")}
            onBlr={formik.handleBlur("title")}
            val={formik.values.title}
          />
          <div className="error">
            {formik.touched.title && formik.errors.title}
          </div>
          {/* <CustomInput
            type="text"
            label="Enter Author Name"
            name="author_name"
            onChng={formik.handleChange("author_name")}
            onBlr={formik.handleBlur("author_name")}
            val={formik.values.author_name}
          />
          <div className="error">
            {formik.touched.authorName && formik.errors.author_name}
          </div> */}
          <div className="">
            <ReactQuill
              theme="snow"
              name="description"
              onChange={formik.handleChange("description")}
              value={formik.values.description}
            />
          </div>
          <div className="error">
            {formik.touched.description && formik.errors.description}
          </div>
          <CustomInput
            type="number"
            label="Enter Product Price"
            name="price"
            onChng={formik.handleChange("price")}
            onBlr={formik.handleBlur("price")}
            val={formik.values.price}
          />
          <div className="error">
            {formik.touched.price && formik.errors.price}
          </div>

          <CustomInput
            type="number"
            label="Enter Current Price"
            name="current_price"
            onChng={formik.handleChange("current_price")}
            onBlr={formik.handleBlur("current_price")}
            val={formik.values.current_price}
          />
          <div className="error">
            {formik.touched.current_price && formik.errors.current_price}
          </div>
          {/* <CustomInput
            type="number"
            label="Enter ISBN No"
            name="isbn"
            onChng={formik.handleChange("isbn")}
            onBlr={formik.handleBlur("isbn")}
            val={formik.values.isbn}
          />
          <div className="error">
            {formik.touched.isbn && formik.errors.isbn}
          </div> */}
          <select
            name="brand"
            onChange={formik.handleChange("brand")}
            onBlur={formik.handleBlur("brand")}
            value={formik.values.brand}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="">Select Brand</option>
            {brandState?.map((i, j) => {
              return (
                <option key={j} value={i.title}>
                  {i.title}
                </option>
              );
            })}
          </select>
          <div className="error">
            {formik.touched.brand && formik.errors.brand}
          </div>
          <select
            name="category"
            onChange={formik.handleChange("category")}
            onBlur={formik.handleBlur("category")}
            value={formik.values.category}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="">Select Category</option>
            {catState?.map((i) => (
              <option key={i._id} value={i.title}>
                {i.title}
              </option>
            ))}
          </select>
          <div className="error">
            {formik.touched.category && formik.errors.category}
          </div>
          <select
            name="tags"
            onChange={formik.handleChange("tags")}
            onBlur={formik.handleBlur("tags")}
            value={formik.values.tags}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="" disabled>
              Select Tag
            </option>
            {tags.length > 0 &&
              tags.map((item, index) => (
                <option value={item.value} key={index + item.value}>
                  {item.name}
                </option>
              ))}
          </select>
          <div className="error">
            {formik.touched.tags && formik.errors.tags}
          </div>

          <Select
            mode="multiple"
            allowClear
            className="w-100"
            placeholder="Select colors"
            defaultValue={color}
            value={color}
            onChange={(i) => handleColors(i)}
            options={coloropt}
          />
          <div className="error">
            {formik.touched.color && formik.errors.color}
          </div>

          <Select
            mode="multiple"
            allowClear
            className="w-100"
            placeholder="Select Sizes (Optional)"
            value={formik.values.size}
            onChange={handleSize}
            options={[
              { label: "S", value: "s" },
              { label: "M", value: "m" },
              { label: "L", value: "l" },
              { label: "XL", value: "xl" },
              { label: "XXL", value: "xxl" },
            ]}
          />
          <div className="error">
            {formik.touched.size && formik.errors.size}
          </div>

          <CustomInput
            type="number"
            label="Enter Product Quantity"
            name="quantity"
            onChng={formik.handleChange("quantity")}
            onBlr={formik.handleBlur("quantity")}
            val={formik.values.quantity}
          />
          <div className="error">
            {formik.touched.quantity && formik.errors.quantity}
          </div>
          <div className="bg-white border-1 p-5 text-center">
            <Dropzone
              onDrop={(acceptedFiles) => dispatch(uploadImg(acceptedFiles))}
            >
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p>
                      Drag 'n' drop some files here, or click to select files
                    </p>
                  </div>
                </section>
              )}
            </Dropzone>
          </div>
          <div className="showimages d-flex flex-wrap gap-3">
            {imgshow?.map((i, j) => {
              return (
                <div className=" position-relative" key={j}>
                  <button
                    type="button"
                    onClick={() => dispatch(delImg(i.public_id))}
                    className="btn-close position-absolute"
                    style={{ top: "10px", right: "10px" }}
                  ></button>
                  <img src={i.url} alt="" width={200} height={200} />
                </div>
              );
            })}
            {imgState?.map((i, j) => {
              return (
                <div className=" position-relative" key={j}>
                  <button
                    type="button"
                    onClick={() => dispatch(delImg(i.public_id))}
                    className="btn-close position-absolute"
                    style={{ top: "10px", right: "10px" }}
                  ></button>
                  <img src={i.url} alt="" width={200} height={200} />
                </div>
              );
            })}
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getProductId !== undefined ? "Edit" : "Add"} Product
          </button>
        </form>
      </div>
    </div>
  );
};

export default Addproduct;